import * as React from "react";
import { Image } from "react-datocms";
import { Tabs } from "../Tabs";
import CopyButton from "../CopyButton";
import { getMainnets, getTestnetsForMainnet, cleanUrl, getAllChains } from "../helpers";
import { GridBase } from "./GridBase";
import { ChainCount } from "../ChainCount";

export function SupportedNetworksGrid({ networks, integrations }) {
    const grid_items = getMainnets(networks).filter((x) => x.weight !== null).sort((a, b) => a.weight - b.weight)
        .concat(getMainnets(networks).filter((x) => x.weight === null).sort((a, b) => a.chainname.localeCompare(b.chainname)))
        .filter((x) => !x.suspended)
        .filter((x) => !x.phantom)
        .filter((x) => x.chainname !== "skale-europa");

    const table_items = getAllChains(networks).filter((x) => x.weight !== null).sort((a, b) => a.weight - b.weight)
        .concat(getAllChains(networks).filter((x) => x.weight === null).sort((a, b) => a.chainname.localeCompare(b.chainname)))
        .filter((x) => !x.phantom)
        .filter((x) => !x.suspended);
    
    const first_ten = table_items.slice(0,10);
    const rest = table_items.slice(10);
    rest.sort((a, b) => {
        const _a: any = a.displayname[0].charAt(0);
        const _b: any = b.displayname[0].charAt(0);

        const aIsNumber = !isNaN(_a);
        const bIsNumber = !isNaN(_b);

        if (aIsNumber && bIsNumber) {
            return Number(a) - Number(b);
        } else if (aIsNumber) {
            return 1;
        } else if (bIsNumber) {
            return -1;
        } else {
            return  a.displayname.localeCompare(b.displayname);
        }
     
    });

    const sorted_table = first_ten.concat(rest);
    
    const sorted_integrations = table_items.sort((a, b) => {
        const stage_a = a.integrationstage ? parseInt(a.integrationstage.stage) : 1;
        const stage_b = b.integrationstage ? parseInt(b.integrationstage.stage) : 1;
        return  stage_a - stage_b;
    });

    integrations.sort((a, b) => {
        return  parseInt(a.stage) - parseInt(b.stage);
    });

    const AsTable = ({withIntegrations = false}) => {
        let cnt = 1;
        const table_data = withIntegrations ? sorted_integrations : sorted_table;
        const newNum: any = [];
        const alphabetically: any = [];

        return   <table>
            <thead>
                <tr>
                    <th />
                    {/* <th /> */}
                    <th></th>
                    <th align="left">Chain Family</th>
                    <th align="left">Chain Name</th>
                    <th align="left">Chain ID</th>
                    <th align="center" >Query via SQL on Increment</th>
                </tr>
            </thead>
            <tbody>
                {
                    table_data.map((n, i) => {
                        let rows: any = [];
                        const integration = n.integrationstage ? parseInt(n.integrationstage.stage) : 1;
                        const firstCharacterCode = n.displayname[0].toLocaleLowerCase().charCodeAt(0);

                        if(withIntegrations && !newNum.includes(integration)){
                            newNum.push(integration);
                            rows.push(<tr>
                                <td className="row-header" colSpan={7}>
                                    <small> Integration Stage {integration} </small>
                                </td>
                            </tr>);
                        }


                        if(!withIntegrations && i === 0){
                            rows.push(<tr>
                                <td className="row-header" colSpan={6}>
                                    <small> Most Popular </small>
                                </td>
                            </tr>);
                        }

                        if(!withIntegrations && i >= 10 && (firstCharacterCode >= 97 && firstCharacterCode <= 103) && !alphabetically.includes("A")){
                            alphabetically.push("A");
                            rows.push(<tr>
                                <td className="row-header" colSpan={6}>
                                    <small>A - G</small>
                                </td>
                            </tr>);
                        }
                        if(!withIntegrations && i >= 10 && (firstCharacterCode >= 104 && firstCharacterCode <= 109) && !alphabetically.includes("H")){
                            alphabetically.push("H");
                            rows.push(<tr>
                                <td className="row-header" colSpan={6}>
                                    <small>H - M</small>
                                </td>
                            </tr>);
                        }
                        if(!withIntegrations && i >= 10 && (firstCharacterCode >= 110 && firstCharacterCode <= 115) && !alphabetically.includes("N")){

                            alphabetically.push("N");
                            rows.push(<tr>
                                <td className="row-header" colSpan={6}>
                                    <small>N - S</small>
                                </td>
                            </tr>);
                        }
                        if(!withIntegrations && i >= 10 && (firstCharacterCode >= 116 && firstCharacterCode <= 122) && !alphabetically.includes("T")){
                            alphabetically.push("T");
                            rows.push(<tr>
                                <td className="row-header" colSpan={6}>
                                    <small>T - Z</small>
                                </td>
                            </tr>);
                        }
                        rows = [...rows,
                            <tr key={n.chainname} >
                                <td><small>{cnt++}</small></td>
                                <td className="image-col">
                                    <Image
                                        data={n.imgwhite.responsiveImage}
                                        pictureClassName="cover-image"
                                    />
                                </td>
                                <td>
                                    {n.displayname}
                                </td>
                                <td>
                                    <div className="flex"><code>{n.chainname}</code> <CopyButton text={n.chainname} /></div>
                                </td>
                                <td className="no-wrap">
                                    <div className="flex">{n.chainid} <CopyButton text={n.chainid} /></div>
                                </td>
                                <td align="center">
                                    {n.increment ? <span className="material-symbols-rounded green">check_box</span> : <span className="material-symbols-rounded red">disabled_by_default</span>}
                                </td>
                            </tr>];

                        return rows;
                    }).concat([<tr key="suspended">
                        <td className="row-header" colSpan={6}> <small> SUSPENDED NETWORKS </small></td>
                    </tr>]).concat(getMainnets(networks).filter((x) => x.suspended).map((n) => {

                        const rows = [<tr key={n.chainname} className="suspended">
                            <td><small>{cnt++}</small></td>
                            <td>
                                <Image
                                    data={n.imgwhite.responsiveImage}
                                    pictureClassName="cover-image"
                                />
                            </td>
                            <td>
                                {n.displayname}
                            </td>
                            <td>
                                <div className="flex"><code>{n.chainname}</code> <CopyButton text={n.chainname} /></div>
                            </td>
                            <td className="no-wrap">
                                <div className="flex">{n.chainid} <CopyButton text={n.chainid} /></div>
                            </td>
                            <td align="center"><span className="material-symbols-rounded red">disabled_by_default</span></td>
                        </tr>];

                        getTestnetsForMainnet(networks, n.chainname).forEach((t) => {
                            rows.push(<tr key={`${t.chainname}-testnet`} className="suspended">
                                <td><small>{cnt++}</small></td>
                                <td>
                                    <Image
                                        data={n.imgwhite.responsiveImage}
                                        pictureClassName="cover-image"
                                    />
                                </td>
                                <td />
                                <td><div className="flex"><code>{t.chainname}</code> <CopyButton text={t.chainname} /></div></td>
                                <td className="no-wrap"><div className="flex">{t.chainid} <CopyButton text={t.chainid} /></div></td>
                                <td align="center"><span className="material-symbols-rounded red">disabled_by_default</span></td>
                            </tr>);
                        });

                        return rows;

                    }).reverse())
                }
                <style jsx>
                    {`
        
                .suspended {
                    opacity: 0.5;
                }
                .no-wrap{
                    white-space: nowrap;
                }
                .image-col{
                    min-width:5rem;
                }

                .green {
                    color: var(--green);
                }
                .red {
                        color: var(--red);
                }

                .material-symbols-rounded {
                    line-height: 2;
                }

        `}
                </style>

            </tbody>
        </table>;
    };

    return <div>
        <p>Covalent indexes <strong><ChainCount chains={networks} /></strong> chains across Mainnets and Testnets.</p>

        <Tabs activeTab="As Logos">

            <div data-label="As Logos">
                <GridBase
                    limit={100}
                    items={grid_items}
                    withLink={(x) => `/docs/networks/${cleanUrl(x.displayname)}/`
                    }
                />
            </div>

            <div data-label="As Table">
                <AsTable/>
            </div>

 
        </Tabs>
    </div>;
}
